<!-- 申请Demo/样品 表单 -->
<template>
    <div class="apply-form-container">
      <van-popup v-model="applyForm" :safe-area-inset-bottom="true">
        <div class="form-container">
          <div class="form-content">
            <div class="btn-switch">
              <button class="btn" @click="clickNav(index,item)" :class="selectNav == index?'select-btn':''" v-for="(item,index) in navList" :key="index">{{item.title}}</button>
            </div>
            <transition name="van-fade">
              <div v-show="showForm">
                <div class="form-list">
                  <div class="item">
                    <label class="hint-title">姓名：<span class="sign">*</span></label>
                    <div class="content">
                      <div class="left-icon">
                        <i class="iconfont icon-xingming"></i>
                      </div>
                      <div class="right-input">
                        <input type="text" placeholder="请输入姓名" v-model="formItem.name" @blur="blurChange">
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <label class="hint-title">手机：<span class="sign">*</span></label>
                    <div class="content">
                      <div class="left-icon">
                        <i class="iconfont icon-dianhua"></i>
                      </div>
                      <div class="right-input">
                        <input type="number" placeholder="请输入手机号" v-model="formItem.mobile" @blur="blurChange">
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <label class="hint-title">邮箱：<span class="sign">*</span></label>
                    <div class="content">
                      <div class="left-icon">
                        <i class="iconfont icon-youxiang"></i>
                      </div>
                      <div class="right-input">
                        <input type="email" placeholder="请输入邮箱" v-model="formItem.email" @blur="blurChange">
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <label class="hint-title">公司：<span class="sign">*</span></label>
                    <div class="content">
                      <div class="left-icon">
                        <i class="iconfont icon-gongsi"></i>
                      </div>
                      <div class="right-input">
                        <input type="text" placeholder="请输入公司名" v-model="formItem.company" @blur="blurChange">
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <label class="hint-title">公司地址：<span class="sign">*</span></label>
                    <div class="content">
                      <div class="left-icon">
                        <i class="iconfont icon-dizhi"></i>
                      </div>
                      <div class="right-input">
                        <input type="text" placeholder="请输入公司地址" v-model="formItem.company_address" @blur="blurChange">
                      </div>
                    </div>
                  </div>
                  <div class="item">
                    <label class="hint-title">职位：</label>
                    <div class="content">
                      <div class="left-icon">
                        <i class="iconfont icon-zhiwei"></i>
                      </div>
                      <div class="right-input">
                        <input type="text" placeholder="请输入职位" v-model="formItem.poistion" @blur="blurChange">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="hint-text">请填写正确的信息，管理员将尽快完成审核， 并与你取得联系</div>
                <button class="commit-btn" @click="commitApplyForm">提交</button>
              </div>

            </transition>
          </div>
        </div>
      </van-popup>
      <van-popup v-model="commitSuccess" :close-on-click-overlay="closeOverlay" :safe-area-inset-bottom="true">
          <div class="success-container">
            <img src="@/assets/img/success.png" class="success-img" alt="">
            <h3 class="h3-tit">提交成功</h3>
            <div class="hint-text">
              <p>管理员将尽快完成审核</p>
              <p>并与您联系,谢谢</p>
            </div>
            <div class="close-icon" @click="closeEvent">
              <i class="iconfont icon-quxiao"></i>
            </div>
          </div>
      </van-popup>
    </div>
</template>

<script>
  import { productApply } from '@/api/product'
  import { throttle } from '@/libs/util'
  import { recordUserTrack } from '@/libs/common'
  export default {
    data () {
      return {
        product_id: '',
        applyForm: false, // 表单是否显示
        navList: [
          {
            id: 1,
            title: '申请Demo'
          },
          {
            id: 2,
            title: '申请样品'
          }
        ],
        selectNav: 0,
        type: 1, // 表填提交的类型 1 申请Demo 2申请样品
        // transitionEffect: 'van-fade', // 过渡效果
        showForm: true,
        commitSuccess: false, // 表单提交成功显示的弹窗
        closeOverlay: false, // 是否在点击遮罩层后关闭
        formItem: {
          name: '', // 名字
          mobile: '', // 手机号
          email: '',
          company: '', // 公司名
          company_address: '', // 公司地址
          poistion: ''
        }
      }
    },
    created () {

    },
    mounted () {

    },
    methods: {
      showApplyForm () {
        this.applyForm = true
      },
      // 切换导航
      clickNav (index, item) {
        this.selectNav = index
        this.type = item.id
        this.showForm = false
        setTimeout(() => {
          this.showForm = true
        }, 200)
        this.initForm()
      },
      // 初始化表单数据
      initForm () {
        var formItem = { ...this.formItem }
        for (var i in formItem) {
          formItem[i] = ''
        }
        this.formItem = formItem
      },
      closeEvent () {
        this.applyForm = false
        this.commitSuccess = false
      },
      blurChange () {
        const timer = setTimeout(() => {
          const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
          window.scrollTo(0, Math.max(scrollHeight - 1, 0))
          clearTimeout(timer)
        }, 100)
      },
      // 单击提交表单
      commitApplyForm () {
        // this.recordTrack() // 记录用户轨迹（测试）
        var valObj = Object.values(this.formItem)
        valObj.splice(5, 1) // 职位为可选
        var indexOf = valObj.indexOf('')
        if (indexOf !== -1) {
          this.$toast('请将表单填写完整')
        } else if (!/^1[23456789]\d{9}$/.test(this.formItem.mobile)) {
          this.$toast('请填写正确的手机号')
        } else if (this.formItem.email.indexOf('@') === -1) {
          this.$toast('请填写正确的Email')
        } else {
          var params = {
            type: this.type,
            product_id: this.product_id
          }
          Object.assign(params, { ...this.formItem })
          if (!this.formItem.poistion) {
            delete this.formItem.poistion
          }
          console.log('打印提交的数据', this.formItem, params)
          this.commotFormPort(params)
          this.recordTrack() // 记录用户轨迹
        }
      },
      /** 网络请求 **/
      // 表单提交
      commotFormPort: throttle(function (params) {
        productApply(params).then(res => {
          if (res.errCode === 0) {
            this.commitSuccess = true
            this.initForm()
          } else {
            this.$toast(res.errMsg)
          }
        }).catch(err => {
          console.log('表单提交失败', err)
          this.$toast('表单提交失败')
        })
      }, 1000),
      recordTrack () {
        var title = ''
        if (this.type === 1) {
          title = `提交了【${this.$parent.detailsObj.title}】产品Demo申请`
        } else {
          title = `提交了【${this.$parent.detailsObj.title}】产品样品申请`
        }
        var params = {
          model: this.type === 1 ? 'product_demo_applay' : 'product_example_applay',
          model_id: this.$parent.id,
          user_id: this.$store.state.user.id,
          title: title,
          action: this.type === 1 ? 'apply_form' : 'sample_form'
        }
        recordUserTrack(params) // 记录用户轨迹
      }
    }
  }
</script>

<style lang="scss" scoped>
.apply-form-container{
  .van-popup{
    border-radius: 6px;
  }
  .form-container{
    width: rem(303);
    height: rem(520);
    background: #fff;
    padding: rem(20) 0;
    .form-content{
      width: 85%;
      height: 100%;
      margin: 0 auto;
      .btn-switch{
        display: flex;
        justify-content: center;
        color: #2c2c2c;
        font-size: 14px;
        margin-bottom: rem(18);
        .btn{
          background: #f5f5f5;
          width: rem(115);
          height: rem(30);
          border: none;
          outline: none;
          border-radius: 4px;
          &:nth-child(even){
            margin-left: 20px;
          }
        }
        .select-btn{
          background: $base-color;
          color: #fff;
          transition: all .2s;
        }
      }
      .form-list{
        .item{
          .hint-title{
            color: #2c2c2c;
            font-size: 12px;
            display: inline-block;
            margin-bottom: 5px;
            .sign{
              color: #d01818;
            }
          }
          .content{
            display: flex;
            align-items: center;
            width: 100%;
            height: rem(30);
            background: #f5f5f5;
            border-radius: 4px;
            margin-bottom: rem(5);
            .left-icon{
              width: 15%;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              .iconfont{
                color: #4d4d4d;
                font-size: rem(18);
              }
              .icon-xingming{
                font-size: rem(15);
              }
              &:after{
                content: '';
                width: 1px;
                height: rem(18);
                background: #afafaf;
                position: absolute;
                top: 50%;
                right: 0;
                margin-top: rem(-9);
              }
            }
            .right-input{
              width: 85%;
              padding-left: rem(10);
              input{
                width: 100%;
                height: rem(30);
                border: none;
                background: none;
              }
            }
          }
        }
      }
      .hint-text{
        color: #9d9d9d;
        font-size: 12px;
      }
      .commit-btn{
        width: rem(170);
        height: rem(40);
        background: $base-color;
        color: #fff;
        font-size: rem(16);
        border-radius: 4px;
        outline: none;
        border: none;
        display: block;
        margin: 0 auto;
        margin-top: rem(20);
        &:active{
          background: #51c0dc;
        }
      }
    }
  }
  .success-container{
    width: rem(303);
    height: rem(250);
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    .success-img{
      width: rem(84);
      height: rem(84);
    }
    .h3-tit{
      font-size: rem(16);
      color: #2c2c2c;
      margin: rem(10) 0;
    }
    .hint-text{
      color: #bdbdbd;
      font-size: 13px;
    }
    .close-icon{
      position: absolute;
      top: rem(15);
      right: rem(15);
      width: rem(20);
      height: rem(20);
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont{
        font-weight: bold;
        font-size: rem(25);
        color: #9d9d9d;
      }
    }
  }
}
</style>
